import { createGlobalStyle } from 'styled-components'
import helpers from './helpers'
import '@enterprise-ui/canvas-ui-css'
import '@enterprise-ui/canvas-ui-css-autocomplete'

const GlobalStyles = createGlobalStyle`
  ${helpers}
`

export default GlobalStyles
